// extracted by mini-css-extract-plugin
export default {"nav":"BottomNav_nav__VfHGh","tab":"BottomNav_tab__i4xtl","icon":"BottomNav_icon__VN7ga","label":"BottomNav_label__WvAcL"};